import { restApiRequestPost, getErrorMessage } from './ajax'

const period = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    /**
     * 期間の一覧を取得する
     * @param {*} params
     */
    getPeriodList: function({ commit }, params) {
      return new Promise((resolve, reject) => {
        const baseURL = process.env.BaseURL
        const advertiserId = params.advertiserId
        const deliveryMonth = params.deliveryMonth
        restApiRequestPost(baseURL, `/api/measurementperiod/list/${params.privateCode}/${advertiserId}/${deliveryMonth}`, params.jwtToken, params)
          .then(result => {
            if (result.status === 200) {
              resolve(parse(result))
            } else {
              reject(new Error('Irregular Error.'))
            }
          })
          .catch(err => {
            if (!err) {
              resolve(undefined)
            } else if (!err.response) {
              reject(new ReferenceError('commons.restapi.system.error'))
              return
            } else if (err.response.data.errorCode === 'permission.expiration.error') {
              reject(new Error(getErrorMessage(err.response.data.errorCode)))
              return
            }
            reject(new ReferenceError(getErrorMessage(err.response.data.errorCode)))
          })
      })
    }
  }
}
function parse(response) {
  return response.data
}
export default period
